var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:({
    src: _vm.bg,
  }),expression:"{\n    src: bg,\n  }",arg:"background-image"}],staticClass:"technologyDivParent"},[_c('title-widge',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"titleColor":_vm.titleColor,"subTitleColor":_vm.subTitleColor}}),_c('div',{staticClass:"divImg"},[_c('img',{attrs:{"src":_vm.bgUrl}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }